import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IRole, IRoleForm } from "../models/role";

@Injectable({
  providedIn: "root",
})
export class RoleService {
  private baseurl: string = "/role";

  public list: IRole[] = [];

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get<IRole[]>(this.baseurl)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async create(data: IRoleForm) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: IRoleForm) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }
}
